import { Component, Fragment } from "react";
import { UserAgentProvider, UserAgent } from "@quentin-sommer/react-useragent";

class Download extends Component {
  render() {
    return (
      <Fragment>
        <UserAgentProvider ua={window.navigator.userAgent}>
          <Fragment>
            <UserAgent computer>
              <Fragment>
                <div className="hero-buttons">
                  <a
                    href={process.env.REACT_APP_DOWNLOAD_IOS}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hero-button"
                  >
                    <img src="/img/white_apple_logo.png" alt="Apple Logo" className="icon" />
                    App Store
                  </a>
                  <a
                    href={process.env.REACT_APP_DOWNLOAD_ANDROID}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hero-button"
                  >
                    <img
                      src="/img/white_playstore_logo.png"
                      alt="Play store Logo"
                      className="icon"
                    />
                    Google Play
                  </a>
                </div>
              </Fragment>
            </UserAgent>
            <UserAgent ios>
              <a
                href={process.env.REACT_APP_DOWNLOAD_IOS}
                target="_blank"
                rel="noopener noreferrer"
                className="hero-button"
              >
                <img src="/img/white_apple_logo.png" alt="Apple Logo" className="icon" />
                App Store
              </a>
            </UserAgent>
            <UserAgent android>
              <a
                href={process.env.REACT_APP_DOWNLOAD_ANDROID}
                target="_blank"
                rel="noopener noreferrer"
                className="hero-button"
              >
                <img src="/img/white_playstore_logo.png" alt="Play store Logo" className="icon" />
                Google Play
              </a>
            </UserAgent>
          </Fragment>
        </UserAgentProvider>
      </Fragment>
    );
  }
}

export default Download;
